import {useRef, useState} from "react";
import classes from "../../../pages/admin/ArticleEdit.module.scss";
import Checkbox from "../../ui/Checkbox";

export default function EmbedEditor({valueRef, part, setPart}){
	const ref = useRef(part.value)
	const [runHtmlAsScript, setRunHtmlAsScript] = useState(part.runAsScript || false);

	const handleChange = (e)=>{
		valueRef.current.value = e.target.value;
	}
	const handleChangeScript = (newVal)=>{
		valueRef.current.runAsScript = newVal;
	}

	return(<>
		<textarea placeholder="Innbygg" defaultValue={part.value} ref={ref} className={classes.bodyPart} required onChange={handleChange}/>
		<Checkbox label={'Kjør som script (utrygt)'} checked={runHtmlAsScript} state={runHtmlAsScript} setState={setRunHtmlAsScript} changeFunc={handleChangeScript}/>
	</>)
}